export default __webpack_public_path__ + "static/media/hotel_img_jp_15.61157ca4.jpg";